// import { Flex } from "@chakra-ui/react";
import { Outlet, useOutletContext /* useLocation */ } from "react-router-dom";

import { useAuth, useProduct, useQueryParam } from "~/hooks";
import { SupportButton } from "~/theme/components";

import { Container, Outdoor } from "./components";

function Layout() {
  const params = useQueryParam("product");
  const auth = useAuth();
  const product = useProduct();
  // const { pathname } = useLocation();

  // const productName = params.product || product.name.toLowerCase();

  // const isTalks = productName === "talks" && pathname === "/signup/";

  if (params.product && !product.id) {
    return null;
  }

  return (
    <>
      <Container src={product.background_image}>
        {(goBack) => (
          <div className="w-full flex flex-wrap items-start justify-center gap-7 md:gap-16 py-10">
            <Outdoor />
            <Outlet context={{ ...product, auth, goBack }} />
          </div>
        )}
      </Container>
      <div className="fixed bottom-10 right-10 z-10 block md:hidden text-basic-white-50">
        <SupportButton />
      </div>
    </>
  );
}

export function useLoggedOut() {
  const params = useOutletContext<
    ReturnType<typeof useProduct> & {
      auth: ReturnType<typeof useAuth>;
      goBack(): void;
    }
  >();

  return params;
}

export default Layout;
